export const MenuIdProjects = 'PROJECTS' as const;
